import { FC } from 'react'

import { GeneratedSite } from '@api/generated-site'
import SiteBenefits, {
  ProofTiles, SiteFaq, FAQ, monthlyLabel, trialEndDate,
} from './SiteBenefits'
import SiteCountdown from './SiteCountdown'

type Props = {
  site: GeneratedSite
  monthlyAmountHt: number | null
  trialDays: number
  onClose: () => void
  // vers le choix des formules (OfferPanel)
  onContinue: () => void
  onAdInterest?: () => void
}

export const trialCtaLabel = (trialDays: number) => (trialDays > 0
  ? `Essayer gratuitement ${trialDays} jours`
  : 'Mettre mon site en ligne')

// « micro landing page » avant le paiement : ce que le site fait, preuves, offre à 0 € aujourd'hui,
// les trois objections les plus fréquentes, puis les formules
const SiteBenefitsPanel: FC<Props> = ({
  site, monthlyAmountHt, trialDays, onClose, onContinue, onAdInterest,
}) => {
  const brand = site.commercialBrand || 'votre entreprise'
  const firstPayment = trialDays > 0 ? trialEndDate(trialDays) : null

  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center p-0 md:p-6">
      <button type="button" aria-label="Fermer" onClick={onClose} className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div className="relative w-full md:max-w-[680px] max-h-[94vh] overflow-y-auto rounded-t-3xl md:rounded-3xl bg-white p-6 md:p-8 shadow-2xl animate-fade-up">
        <button type="button" onClick={onClose} aria-label="Fermer" className="absolute right-4 top-4 h-9 w-9 rounded-full bg-black/5 text-lg leading-none hover:bg-black/10">×</button>

        <SiteBenefits
          brand={brand}
          monthlyAmountHt={monthlyAmountHt}
          trialDays={trialDays}
          onAdInterest={onAdInterest}
          adInterestRecorded={!!site.adInterestAt}
        />

        <div className="mt-6"><ProofTiles variant="light" /></div>

        {site.expiresAt && !site.purchasedAt && (
          <div className="mt-6"><SiteCountdown expiresAt={site.expiresAt} variant="light" /></div>
        )}

        <div className="mt-6 rounded-2xl bg-black/[0.04] p-4">
          <div className="text-[11px] uppercase tracking-[0.2em] text-black/50 mb-1">Vos questions</div>
          <SiteFaq variant="light" items={FAQ.slice(0, 3)} />
        </div>

        <button
          type="button"
          onClick={onContinue}
          className="mt-6 w-full rounded-2xl bg-black py-4 px-5 text-left text-white hover:bg-black/90"
        >
          <div className="font-aeonik text-lg font-medium leading-tight">{trialCtaLabel(trialDays)}</div>
          <div className="text-xs text-white/70 mt-1">
            {trialDays > 0 && firstPayment
              ? `0 € aujourd’hui, puis ${monthlyLabel(monthlyAmountHt)} à partir du ${firstPayment} · sans engagement · arrêt en un clic`
              : 'Réglé avec la carte enregistrée sur votre compte, sans ressaisie'}
          </div>
        </button>
        <button type="button" onClick={onContinue} className="mt-3 w-full text-center text-sm text-black/60 underline underline-offset-4 hover:text-black">
          Voir toutes les formules (1 mois, 1 an, 2 ans, 3 ans)
        </button>
      </div>
    </div>
  )
}

export default SiteBenefitsPanel
